"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfSettings = void 0;
var PdfSettings = (function () {
    function PdfSettings() {
        this._pdfDocument = window.PDFDocument;
        this._blobStream = window.BlobStream;
    }
    Object.defineProperty(PdfSettings.prototype, "pdfDocument", {
        get: function () { return this._pdfDocument ? this._pdfDocument : window.PDFDocument; },
        set: function (val) { this._pdfDocument = val; },
        enumerable: false,
        configurable: true
    });
    ;
    ;
    Object.defineProperty(PdfSettings.prototype, "blobStream", {
        get: function () { return this._blobStream ? this._blobStream : window.BlobStream; },
        set: function (val) { this._blobStream = val; },
        enumerable: false,
        configurable: true
    });
    ;
    ;
    PdfSettings.prototype.copyFrom = function (obj) {
        this._pdfDocument = obj.pdfDocument;
        this._blobStream = obj.blobStream;
        this.exportUrl = obj.exportUrl;
        this.pdfKitScriptUrl = obj.pdfKitScriptUrl;
        this.convertImageToCompatibleFormat = obj.convertImageToCompatibleFormat;
    };
    PdfSettings.prototype.clone = function () {
        var result = new PdfSettings();
        result.copyFrom(this);
        return result;
    };
    return PdfSettings;
}());
exports.PdfSettings = PdfSettings;
